import $ from "jquery";
import _ from "lodash";
import ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax, TweenLite } from "gsap";
import "animation.gsap";
import "debug.addIndicators";

import controller from "../scroll/controller";

$(".block-sticky-performance-peaks").each(function() {
  let $block = $(this);
  let block = $block[0];
  let blockH = $block.height();

  let $sticky = $block.find(".sticky");
  let sticky = $sticky[0];
  let stickyH = $sticky.height();

  let scenes = [];

  let $texts = $block.find(".texts");
  let $text = $block.find(".text");
  let textCount = $text.length;

  let count = $text.length - 1;

  let active = 0;

  let $svgGroup = $block.find("svg g g");
  let $performancePeaks = $block.find("#performance-peaks");

  let $pill = $block.find(".pill");
  let $peak = $block.find(".peak");
  let $label = $block.find(".label");

  let $bluePeak = $block.find("#peak-blue");
  let $greenPeak = $block.find("#peak-green");
  let $yellowPeak = $block.find("#peak-yellow");
  let $orangePeak = $block.find("#peak-orange");
  let $redPeak = $block.find("#peak-red");

  const tlPeaks = new TimelineMax();
  const tlPeaksSetup = new TimelineMax();

  const pr = { val: 0, endVal: "49%", pos: 49, neg: 51 };
  const po = { val: 0, endVal: "46%", pos: 46, neg: 54 };
  const py = { val: 0, endVal: "96%", pos: 96, neg: 4 };
  const pg = { val: 0, endVal: "41%", pos: 41, neg: 59 };
  const pb = { val: 0, endVal: "48%", pos: 48, neg: 52 };

  tlPeaksSetup
    .set("#peak-red", { xPercent: 60, yPercent: 100 })
    .set("#peak-orange", { xPercent: 40, yPercent: 100 })
    .set("#peak-yellow", { xPercent: 0, yPercent: 100 })
    .set("#peak-green", { xPercent: -40, yPercent: 100 })
    .set("#peak-blue", { xPercent: -60, yPercent: 100 })
    .set("#pill-red", { top: "100%", left: "86%", opacity: 0 })
    .set("#pill-orange", { top: "100%", left: "74%", opacity: 0 })
    .set("#pill-yellow", { top: "100%", left: "50%", opacity: 0 })
    .set("#pill-green", { top: "100%", left: "26%", opacity: 0 })
    .set("#pill-blue", { top: "100%", left: "14%", opacity: 0 })
    .set("#label-red", { opacity: 0 })
    .set("#label-orange", { opacity: 0 })
    .set("#label-yellow", { opacity: 0 })
    .set("#label-green", { opacity: 0 })
    .set("#label-blue", { opacity: 0 });

  tlPeaks
    .to("#peak-blue", 1, { ease: Power4.easeOut, yPercent: pb.neg })
    .to("#pill-blue", 0.25, { ease: Power4.easeOut, opacity: 1 }, "=-1")
    .to("#pill-blue", 1, { ease: Power4.easeOut, top: `${pb.neg}%` }, "=-1")
    .to("#label-blue", 0.25, { opacity: 1 }, "=-1")
    .to(
      pb,
      1,
      {
        val: pb.endVal,
        ease: Power4.easeOut,
        roundProps: "val",
        onUpdate: () => {
          document.getElementById("pill-blue").innerHTML = pb.val;
        }
      },
      "=-1"
    )
    .to("#peak-green", 1, { ease: Power4.easeOut, yPercent: pg.neg }, "=-.75")
    .to("#pill-green", 0.25, { ease: Power4.easeOut, opacity: 1 }, "=-1")
    .to("#pill-green", 1, { ease: Power4.easeOut, top: `${pg.neg}%` }, "=-1")
    .to("#label-green", 0.25, { opacity: 1 }, "=-1")
    .to(
      pg,
      1,
      {
        val: pg.endVal,
        ease: Power4.easeOut,
        roundProps: "val",
        onUpdate: () => {
          document.getElementById("pill-green").innerHTML = pg.val;
        }
      },
      "=-1"
    )
    .to("#peak-yellow", 1, { ease: Power4.easeOut, yPercent: py.neg }, "=-.75")
    .to("#pill-yellow", 0.25, { ease: Power4.easeOut, opacity: 1 }, "=-1")
    .to("#pill-yellow", 1, { ease: Power4.easeOut, top: `${py.neg}%` }, "=-1")
    .to("#label-yellow", 0.25, { opacity: 1 }, "=-1")
    .to(
      py,
      1,
      {
        val: py.endVal,
        ease: Power4.easeOut,
        roundProps: "val",
        onUpdate: () => {
          document.getElementById("pill-yellow").innerHTML = py.val;
        }
      },
      "=-1"
    )
    .to("#peak-orange", 1, { ease: Power4.easeOut, yPercent: po.neg }, "=-.75")
    .to("#pill-orange", 0.25, { ease: Power4.easeOut, opacity: 1 }, "=-1")
    .to("#pill-orange", 1, { ease: Power4.easeOut, top: `${po.neg}%` }, "=-1")
    .to("#label-orange", 0.25, { opacity: 1 }, "=-1")
    .to(
      po,
      1,
      {
        val: po.endVal,
        ease: Power4.easeOut,
        roundProps: "val",
        onUpdate: () => {
          document.getElementById("pill-orange").innerHTML = po.val;
        }
      },
      "=-1"
    )
    .to("#peak-red", 1, { ease: Power4.easeOut, yPercent: pr.neg }, "=-.75")
    .to("#pill-red", 0.25, { ease: Power4.easeOut, opacity: 1 }, "=-1")
    .to("#pill-red", 1, { ease: Power4.easeOut, top: `${pr.neg}%` }, "=-1")
    .to("#label-red", 0.25, { opacity: 1 }, "=-1")
    .to(
      pr,
      1,
      {
        val: pr.endVal,
        ease: Power4.easeOut,
        roundProps: "val",
        onUpdate: () => {
          document.getElementById("pill-red").innerHTML = pr.val;
        }
      },
      "=-1"
    );

  const variables = () => {
    blockH = $block.height();
    stickyH = $sticky.height();
    scenes = [];
  };

  const deleteScenes = () => {
    if (scenes.length) {
      scenes.forEach(function(scene) {
        scene.destroy(true);
      });
    }
  };

  const padding = () => {
    $texts.css({
      "padding-top": stickyH / 3.5,
      "padding-bottom": stickyH / 3.5
    });
  };

  const movePeak = index => {
    if (index == 0) {
      $bluePeak.appendTo($svgGroup);
      $redPeak.appendTo($svgGroup);
      $yellowPeak.appendTo($svgGroup);
      $orangePeak.appendTo($svgGroup);
      $greenPeak.appendTo($svgGroup);
    } else if (index == 1 || index == "blue") {
      $bluePeak.appendTo($svgGroup);
    } else if (index == 2 || index == "green") {
      $greenPeak.appendTo($svgGroup);
    } else if (index == 3 || index == "yellow") {
      $yellowPeak.appendTo($svgGroup);
    } else if (index == 4 || index == "orange") {
      $orangePeak.appendTo($svgGroup);
    } else if (index == 5 || index == "red") {
      $redPeak.appendTo($svgGroup);
    }
  };

  const scrollTo = el => {
    let windowH = $(window).height();
    let elH = el.outerHeight();
    let scrollAmount = (windowH - elH) / 2 - 150; // 150 is half of the top padding
    let scrollTo = el.offset().top - scrollAmount;

    $("html, body").animate(
      {
        scrollTop: scrollTo
      },
      500
    );
  };

  const moveToText = colour => {
    if (colour == "blue") {
      scrollTo($block.find(".text-1"));
    } else if (colour == "green") {
      scrollTo($block.find(".text-2"));
    } else if (colour == "yellow") {
      scrollTo($block.find(".text-3"));
    } else if (colour == "orange") {
      scrollTo($block.find(".text-4"));
    } else if (colour == "red") {
      scrollTo($block.find(".text-5"));
    }
  };

  const addHoverClass = colour => {
    $performancePeaks.addClass(`hover-${colour}`);
    movePeak(colour);
  };

  const removeHoverClass = () => {
    $performancePeaks.removeClass(
      "hover-blue hover-green hover-yellow hover-orange hover-red"
    );
    movePeak(active);
  };

  const setActive = index => {
    active = index;
  };

  const enterTextScene = (event, index, $element) => {
    $text.eq(index).addClass("show");
    $("#performance-peaks").removeClass();
    $("#performance-peaks").addClass(`active-${index}`);
    setActive(index);
    movePeak(index);
  };

  const leaveTextScene = (event, index, $element) => {
    if (event.scrollDirection == "REVERSE" && index == 0) return;
    if (event.scrollDirection == "FORWARD" && index == count) return;
    $text.eq(index).removeClass("show");
  };

  const blockScenes = () => {
    const pinScene = new ScrollMagic.Scene({
      duration: blockH - stickyH,
      offset: stickyH / 2,
      triggerHook: "onCenter",
      triggerElement: block
    })
      .setPin(sticky)
      // .addIndicators()
      .addTo(controller);

    const animationScene = new ScrollMagic.Scene({
      offset: 0,
      triggerHook: "onCenter",
      triggerElement: block
    })
      .setTween(tlPeaks)
      // .addIndicators()
      .addTo(controller);

    scenes.push(pinScene);
    scenes.push(animationScene);
  };

  const textScenes = () => {
    $text.each(function(index) {
      let $this = $(this);
      let scene = new ScrollMagic.Scene({
        duration: $this.outerHeight(),
        offset: 0,
        triggerHook: 0.5,
        triggerElement: $this[0]
      })
        // .addIndicators()
        .addTo(controller)
        .on("enter", function(event) {
          enterTextScene(event, index, $this);
        })
        .on("leave", function(event) {
          leaveTextScene(event, index, $this);
        });
      scenes.push(scene);
    });
  };

  $peak.on("mouseenter", function() {
    let id = $(this).attr("id");
    let colour = id.split("-");
    addHoverClass(colour[1]);
  });

  $pill.on("mouseenter", function() {
    let id = $(this).attr("id");
    let colour = id.split("-");
    addHoverClass(colour[1]);
  });

  $label.on("mouseenter", function() {
    let id = $(this).attr("id");
    let colour = id.split("-");
    addHoverClass(colour[1]);
  });

  $peak.on("mouseleave", removeHoverClass);
  $pill.on("mouseleave", removeHoverClass);
  $label.on("mouseleave", removeHoverClass);

  $peak.on("click", function() {
    let id = $(this).attr("id");
    let colour = id.split("-");
    moveToText(colour[1]);
  });

  $pill.on("click", function() {
    let id = $(this).attr("id");
    let colour = id.split("-");
    moveToText(colour[1]);
  });

  $label.on("click", function() {
    let id = $(this).attr("id");
    let colour = id.split("-");
    moveToText(colour[1]);
  });

  const init = () => {
    deleteScenes();
    if (window.innerWidth > 768) {
      padding();
      variables();
      blockScenes();
      textScenes();
    }
  };

  init();
  $(window).on("resize", _.debounce(init, 100));
});
